// extracted by mini-css-extract-plugin
export default {"swiper":"UserOnboardingModal_swiper__MTVwZ"};